import Vue from 'vue'
import VueRouter from 'vue-router'
import Welcome from '../views/Welcome.vue'
import About from '../views/About.vue'
import Studio from '../views/Studio.vue'

import ShuttleList from '@/components/shuttle/ShuttleList.vue'
import ShuttlePlay from '@/components/shuttle/ShuttlePlay.vue'
import ShuttleWebinarList from '@/components/shuttle/ShuttleWebinarList.vue'
import ShuttleEdit from '@/components/shuttle/ShuttleEdit.vue'
import ShuttlePreview from '@/components/shuttle/ShuttlePreview.vue'
import ShuttlePublic from '@/components/shuttle/ShuttlePublic.vue'
import ShuttleNamedEntities from '@/components/shuttle/ShuttleNamedEntities.vue'


import processLogin from '@/components/login/processLogin.vue'


import {getBasePath} from '@/mixins/path.js'
Vue.use(VueRouter)


var mybp = getBasePath();


const routes = [
  { path: '*', redirect: '/' },
  {
    path: '/',
    name: 'Home',
    component: Welcome,
    children: [
      {
        path: '/sign-up',
        name: 'SignUp',
        component: () => import('@/components/login/SignUp.vue')
      },
      {
        path: '/forgot-password',
        name: 'ForgottenPassword',
        component: () => import('@/components/login/ForgottenPassword.vue'),
      },
      {
        path: '/confirm-sign-up',
        name: 'ConfirmSignUp',
        component: () => import('@/components/login/ConfirmSignUp.vue')
      },
      {
        path: '/login',
        name: 'Login',
        component: () => import('@/components/login/Login.vue'),
      },
    ]
  },
  {
    path: '/about',
    name: 'About',
    component: Welcome
  },

  {
    path: '/processlogin',
    name: 'ProcessLogin',
    component: processLogin
  },


  {
    path: '/play/:id',
    component: ShuttlePlay
  },

    {
    path: '/public/:id',
    component: ShuttlePublic
  },


  {
    path: '/studio',
    name: 'Studio',
    component: Studio,
    children:[
      {
        path:'list/:id',
        name:'Shuttle List',
        component: ShuttleList,

        props: true,

      },
      {
        path:'webinar',
        component: ShuttleWebinarList

      },
      {
        path:'edit/:id',
        component: ShuttleEdit

      },
      {
        path:'preview/:id',
        component: ShuttlePreview

      },
      {
        path:'key-entities',
        component: ShuttleNamedEntities

      }
    ]
  },

  {
      path: '/settings',
      name: 'Settings',
      component: Studio,
      children: [
        {
          path:'list/:id',
          name:'Settings List',
          component: () => import('@/components/settings/ShuttleSettingsList.vue'),
          props:true
        },
        {
          path:'edit/:id',
          name:'Settings Edit',
          component: () => import('@/components/settings/ShuttleSettingsEdit.vue'),
        }
      ]
  },

  {
    path: '/quiz',
    name: 'Quiz',
    component: Studio,
    children:[
      {
        path:'list/:id',
        name:'Quiz List',
        component: () => import('@/components/quiz/QuizList.vue'),

        props: true,

      },
      {
        path:'edit/:id',
        name:'Quiz Edit',
        component: () => import('@/components/quiz/QuizEdit.vue'),

      }
    ]
  }




]


console.log('Base PAth: ' + mybp)

const router = new VueRouter({
  base:mybp,
  mode: 'history',
  hash: false,
  routes
});


export default router
